import React from 'react';

import { PrismicRichText } from '@prismicio/react';
import { H1, H2, H3 } from '@repo/ui/components/Typography';
import { themeStyle } from '@repo/ui/theming';

import ContentWrapper from 'components/Landing/ContentWrapper/ContentWrapper';
import { getMediaCdnUrl } from 'global/prismicUtils';
import useWindowSize from 'global/utils/useWindowSize';
import { FlexRow } from 'styles/layouts';

import BannerButton from './BannerButton';
import { Background, Content, Text, H1XL, H2XL } from './styles';

const getGap = (type, isMobile) => {
  if (isMobile) {
    if (type === 'h1') {
      return '18px';
    }
    return '8px';
  }

  if (type === 'h1') {
    return '24px';
  }
  return '16px';
};

const getTitle = (type, title, hasBackgroundImage) => {
  const color = hasBackgroundImage ? themeStyle.inkBase : themeStyle.varInkMain;

  if (type === 'h1') {
    return <H1 color={color}>{title}</H1>;
  }
  if (type === 'h1Xl') {
    return <H1XL color={color}>{title}</H1XL>;
  }
  if (type === 'h3') {
    return <H3 color={color}>{title}</H3>;
  }
  if (type === 'h2Xl') {
    return <H2XL color={color}>{title}</H2XL>;
  }
  return <H2 color={color}>{title}</H2>;
};

const Banner = ({ slice }) => {
  const { isMobile } = useWindowSize();
  const gap = getGap(slice.primary.type, isMobile);
  const hasBackgroundImage = !!slice.primary.background?.url;

  return (
    <ContentWrapper background="white" className="banner" customWidth="1344px">
      <Background image={getMediaCdnUrl(slice.primary.background?.url)}>
        <Content
          gap={gap}
          innerContentWidth={slice.primary.innerContentWidth || '430px'}
        >
          {getTitle(
            slice.primary.type,
            slice.primary.title,
            hasBackgroundImage
          )}
          {slice.primary.text && (
            <Text
              as="div"
              color={
                hasBackgroundImage ? themeStyle.inkBase : themeStyle.varInkMain
              }
            >
              <PrismicRichText field={slice.primary.text} />
            </Text>
          )}
          {!!slice.items?.length && (
            <FlexRow
              gap={gap}
              justifyContent="center"
              style={{ flexWrap: 'wrap' }}
            >
              {slice.items.map((item, index) => {
                return (
                  <BannerButton
                    key={index}
                    {...item}
                    useLightTheme={hasBackgroundImage}
                  />
                );
              })}
            </FlexRow>
          )}
        </Content>
      </Background>
    </ContentWrapper>
  );
};

export default Banner;
